import { Label } from '@/components/ui/label'

export interface AssignableTeam {
  id: number
  name: string
  members: { id: number; name: string }[]
}

interface TeamGroupedUserPickerProps {
  assignableTeams: AssignableTeam[]
  selectedIds: number[]
  onToggle: (userId: number) => void
}

// Team-grouped multi-select for assigning individual users to a campaign.
// A user belonging to several teams shows under each team header, but every
// checkbox reflects the same `user_id` toggle, so they can never be
// double-assigned (the DB uniqueness index is a backstop, not the UX).
export function TeamGroupedUserPicker({
  assignableTeams,
  selectedIds,
  onToggle,
}: TeamGroupedUserPickerProps) {
  return (
    <div className="space-y-2">
      <Label>Personnes</Label>
      {assignableTeams.length === 0 ? (
        <div className="rounded-md border p-3 text-sm text-muted-foreground">
          Aucun membre disponible — créez une équipe avec des membres d'abord.
        </div>
      ) : (
        <div className="space-y-3 rounded-md border p-3 max-h-56 overflow-y-auto">
          {assignableTeams.map((team) => (
            <div key={team.id} className="space-y-1">
              <p className="text-xs font-medium text-muted-foreground">
                {team.name}
              </p>
              {team.members.map((member) => (
                <label
                  key={member.id}
                  className="flex items-center gap-2 text-sm cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(member.id)}
                    onChange={() => onToggle(member.id)}
                    className="rounded border-gray-300"
                  />
                  {member.name}
                </label>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
